import React, { Component } from "react";
import { Form } from "react-form";
import { connect } from "react-redux";
import ReactPaginate from "react-paginate";
import moment from "moment";
import { map } from "lodash";
import DatePickerUI from "../UI/DatePicker";
import {
  getDriversSettlement,
  getSearchDriversSettlement
} from "../../store/actions/reportsSettlement";

class Settlements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      settlmentLength: 0,
      dateFrom: "",
      dateTo: ""
    };
  }

  async componentDidMount() {
    await this.props.getDriversSettlement(
      this.props.auth.token,
      1,
      this.props.match.params.id,
      this.state.dateFrom,
      this.state.dateTo
    );

    let settlmentsReportShow = [];
    map(this.props.reportsSettlement.results, data => {
      settlmentsReportShow.push(data);
    });
    if (this.state.settlmentLength <= settlmentsReportShow.length) {
      this.setState({ settlmentLength: settlmentsReportShow.length });
    }
  }
  handleClick = pagenumber => {
    this.props.getDriversSettlement(
      this.props.auth.token,
      pagenumber.selected + 1,
      this.props.match.params.id,
      this.state.dateFrom,
      this.state.dateTo
    );
  };
  dateFrom = async (lag, date) => {
    if (lag === "From") {
      await this.setState({
        dateFrom: moment(date).format("YYYY-MM-DD")
      });
    } else if (lag === "To") {
      await this.setState({
        dateTo: moment(date).format("YYYY-MM-DD")
      });
    }
    this.props.getSearchDriversSettlement(
      this.props.auth.token,
      1,
      this.props.match.params.id,
      this.state.dateFrom,
      this.state.dateTo
    );
  };

  render() {
    const settlement = { ...this.props.reportsSettlement };

    let currentSettlmentsCount =
      this.state.settlmentLength > 0
        ? this.state.settlmentLength
        : settlement.count;
    let pageCount = Math.ceil(settlement.count / currentSettlmentsCount);

    return (
      <React.Fragment>
        <div className="page-title">
          <div className="container">
            <div className="row flex-center-y justify-between">
              <div className="col-xs-12">
                <h1 className="color-grey">Settlements</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="container box py-15">
          <Form onSubmit={this.submitted}>
            {formApi => (
              <form onSubmit={formApi.submitForm}>
                <div className="row">
                  <div className="col-xs-2">
                    <DatePickerUI
                      label="From"
                      hintText="From"
                      dateFrom={this.dateFrom}
                    />
                  </div>
                  <div className="col-xs-2 ml-30">
                    <DatePickerUI
                      label="To"
                      hintText="To"
                      dateFrom={this.dateFrom}
                    />
                  </div>
                </div>
              </form>
            )}
          </Form>
          <div className="table mt-20">
            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Settled Amount</th>
                </tr>
              </thead>
              <tbody>
                {map(settlement.results, data => (
                  <tr key={data.id}>
                    <td>{moment(data.created).format("YYYY-MM-DD")}</td>
                    <td>{moment(data.created).format("h:mm")} </td>
                    <td>{data.amount} SAR</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {pageCount > 1 && (
          <ReactPaginate
            onPageChange={this.handleClick}
            pageCount={pageCount}
            initialPage={0}
            breakClassName={"break-me"}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            previousLabel={<i className="fa fa-chevron-left" />}
            nextLabel={<i className="fa fa-chevron-right" />}
          />
        )}
      </React.Fragment>
    );
  }
}
function mapStateToProps(state) {
  return {
    reportsSettlement: state.reportsSettlement,
    auth: state.auth
  };
}
export default connect(
  mapStateToProps,
  { getDriversSettlement, getSearchDriversSettlement }
)(Settlements);



// WEBPACK FOOTER //
// ./src/components/Finance/Settlements.js